import { useState } from "react";
import { Dialog } from "@shared/ui/Dialog";
import { useDialog } from "@shared/features/dialog/useDialog";
import { useNavigate } from "react-router-dom";
import { useCustomMeetingManager } from "@platform/features/video/hooks/useCustomMeetingManager";
import { stopChimeStreams, stopAllTrackedStreams, forceStopAllMediaStreams } from "@platform/features/video/utils/stopChimeStreams";

export function VideoUIEndMeetingDialog() {
  const navigate = useNavigate();

  const { activeDialog, closeDialog } = useDialog();

  const [isLeaving, setIsLeaving] = useState(false);

  const { leaveMeeting, meetingDetails, meetingManager } = useCustomMeetingManager();

  const handleLeaveMeeting = async (): Promise<void> => {
    try {
      setIsLeaving(true);

      // First stop all tracked streams (most reliable)
      stopAllTrackedStreams();
      
      // Then stop Chime SDK streams properly
      await stopChimeStreams(meetingManager);
      
      // Finally force stop any remaining media streams
      forceStopAllMediaStreams();

      // Then leave the meeting
      await leaveMeeting();
      
      navigate(`/video/end/${meetingDetails?.id}`);
    } catch (err) {
      // Even if there's an error, try to stop streams and redirect
      stopAllTrackedStreams();
      await stopChimeStreams(meetingManager);
      forceStopAllMediaStreams();
      navigate(`/video/end/${meetingDetails?.id}`);
    } finally {
      setIsLeaving(false);
      closeDialog("endMeeting");
    }
  };

  const isOpen = activeDialog === "endMeeting";

  const handleClose = () => {
    closeDialog("endMeeting");
  };

  return (
    <Dialog
      isOpen={isOpen}
      onClose={handleClose}
      title="Leave Meeting"
      description="Are you sure you want to leave the meeting?"
      isWithActions={true}
      primaryButtonText={isLeaving ? "Leaving..." : "Leave Meeting"}
      primaryButtonProps={{
        disabled: isLeaving,
        destructive: true,
      }}
      secondaryButtonText="Cancel"
      onPrimaryClick={handleLeaveMeeting}
      onSecondaryClick={handleClose}
    />
  );
}

export default VideoUIEndMeetingDialog;
``;
